import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';


function RightSidebarContainer({children, closeLink, fullHeight, onClose}) {

  
  return (
    <div className={"flex flex-col flex-auto w-full" + (fullHeight ? " h-full" : "")}>
      
      {closeLink && 
      <IconButton
        className="absolute top-0 right-0 my-16 mx-32 z-10"
        sx={{ color: 'black' }}
        component={NavLinkAdapter}
        to={closeLink}
        onClick={onClose}
        size="large"
      >
        <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
      </IconButton>
      }
      
      { children }

    </div>
  );
}


export default RightSidebarContainer;
